import React, { useState, useEffect } from 'react';

const ServiceSection = () => {
    const [data, setData] = useState({
        heading: "Our Services",
        subheading: "Explore a spectrum of transformative services at MobiCloud, where innovation meets excellence.",
        services: [
            {
                icon: "fas fa-cloud",
                title: "Cloud Services",
                description: "Leverage the power of the cloud with our tailored solutions. From seamless migration to efficient optimization, our cloud services ensure scalability, security, and enhanced efficiency."
            },
            {
                icon: "fas fa-digital-tachograph",
                title: "Digital Transformation",
                description: "Embark on a transformative journey with MobiCloud's digital solutions. We empower businesses to evolve, adapt, and thrive in the dynamic landscape of the digital era."
            },
            {
                icon: "fas fa-code",
                title: "Application Services",
                description: "Unlock the full potential of custom software applications with MobiCloud. Our services cover the entire development lifecycle, delivering solutions that align with your unique business needs."
            },
            {
                icon: "fas fa-cogs",
                title: "Engineering Services",
                description: "Innovate with confidence through MobiCloud's engineering expertise. Our range of engineering services ensures that your ideas become reality with cutting-edge solutions."
            },
            {
                icon: "fas fa-mobile-alt",
                title: "Mobile Apps",
                description: "Empower your business with MobiCloud's Mobile App development services. We design and develop intuitive, feature-rich applications for iOS and Android platforms."
            },
            {
                icon: "fas fa-brain",
                title: "AI & Machine Learning",
                description: "Harness the power of artificial intelligence and machine learning with MobiCloud's specialized services. Our AI and ML solutions analyze data, uncover insights, and automate processes."
            }
        ]
    });

    return (
        <section id="services" className="section service-area bg-gray overflow-hidden ptb_100">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 col-lg-8">
                        <div className="section-heading text-center mb-5">
                            <h2 className="text-capitalize mb-4">{data.heading}</h2>
                            <p className="text-muted fs-5">{data.subheading}</p>
                        </div>
                    </div>
                </div>
                <div className="row">
                    {data.services.map((service, idx) => (
                        <div key={idx} className="col-12 col-md-6 col-lg-4 mb-4">
                            <div className="single-service text-center p-4 h-100 bg-white rounded shadow-sm">
                                <div className="service-icon mb-4">
                                    <div className="icon-box bg-primary text-white rounded-circle d-inline-flex align-items-center justify-content-center" style={{width: '80px', height: '80px'}}>
                                        <i className={`${service.icon} fa-2x`}></i>
                                    </div>
                                </div>
                                <div className="service-text">
                                    <h4 className="mb-3">{service.title}</h4>
                                    <p className="text-muted">{service.description}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="row justify-content-center mt-5">
                    <div className="col-12 text-center">
                        <a href="#contact" className="btn btn-primary btn-lg">Get Started Today</a>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ServiceSection; 